import styled, { css } from 'styled-components';
import { Tooltip } from '@prisjakt/ui/tooltip';
import { layout, media } from 'src/components/base';

export const ClearFilterTooltip = styled(Tooltip)`
  flex-grow: 0;
  flex-shrink: 1;
`;

export const ToggleColumnTooltip = styled(Tooltip)`
  flex-grow: 0;
  flex-shrink: 1;
`;

export const PanelWrapper = styled.div<{
  horizontal?: boolean;
  hideLine?: boolean;
}>`
  border-bottom: 1px solid ${({ theme }) => theme.lines.secondary};

  ${({ horizontal, theme }) =>
    horizontal
      ? css`
          border-bottom: 1px solid ${theme.lines.primary};
        `
      : null}

  ${({ hideLine }) =>
    hideLine
      ? css`
          border-bottom: 0;
        `
      : null}
`;

export const PanelInner = styled.div<{ horizontal?: boolean }>`
  ${({ horizontal }) =>
    horizontal
      ? css`
          display: flex;
        `
      : null}
`;

export const PanelHeader = styled.div<{ horizontal?: boolean }>`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${layout.measurements.spacing075};

  ${({ horizontal }) =>
    horizontal
      ? css`
          width: 250px;
          flex: none;
          align-self: flex-start;
        `
      : null}
`;

export const PanelTitleWrapper = styled.div`
  width: 100%;
  max-width: 150px;
  flex-direction: row;
  display: flex;
  align-items: center;
`;

export const PanelTitle = styled.h6`
  margin: 0;
  display: block;
  font-size: 1rem;
  color: ${({ theme }) => theme.text.secondary};
  padding: 0.8em 0;
`;

export const PanelTitleUnit = styled.span`
  margin-left: 5px;
  color: $text-color-alt;
`;

export const PanelIcon = styled.button<{ hidden?: boolean }>`
  cursor: pointer;
  display: flex;

  & svg {
    fill: ${({ theme }) => theme.icons.callToAction};
  }

  &:hover svg {
    fill: ${({ theme }) => theme.icons.callToActionHover};
  }

  ${({ hidden }) =>
    hidden
      ? css`
          visibility: hidden;
        `
      : null}
`;

export const PanelCompareIcon = styled.button<{
  selected?: boolean;
  enabled?: boolean;
}>`
  display: none;
  cursor: pointer;

  ${({ selected, theme }) => css`
    & svg {
      fill: ${selected ? theme.icons.callToAction : theme.icons.quaternary};
    }
  `}

  ${({ selected, theme }) =>
    css`
      &:hover svg {
        fill: ${selected
          ? theme.icons.callToActionHover
          : theme.icons.callToAction};
      }
    `}

  ${media.largeUp`
    display: flex;
  `}
`;

export const PanelFilter = styled.div`
  padding: 0 ${layout.measurements.spacing075};
  flex: 1 1;
`;
